import type { SVGProps } from 'react'

export const LoadingCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="5" stroke="#D0B3FF" />
    <path
      d="M16.9 13C16.8294 13.3478 16.7227 13.6825 16.584 14C16.428 14.357 16.2315 14.6923 16.0004 15C15.7158 15.3788 15.3788 15.7159 15 16.0004C14.6923 16.2315 14.357 16.428 14 16.584"
      stroke="#6224C6"
      strokeLinecap="round"
    />
  </svg>
)
